import React from 'react';
import { Twitter, Linkedin, Instagram, Youtube } from 'lucide-react';
import { mockData } from '../mock/data';

const socialIconMap = {
  Twitter,
  LinkedIn: Linkedin,
  Instagram,
  Youtube
};

export const Footer = () => {
  const { footer } = mockData;

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-grid-simple">
          {/* Company Info */}
          <div className="footer-column footer-brand">
            <div className="footer-logo-wrapper">
              <img 
                src="https://customer-assets.emergentagent.com/job_pips-recruit/artifacts/gsidg3r5_WhatsApp%20Image%202026-01-19%20at%2017.04.44.jpeg"
                alt="Sofia Investe" 
                className="footer-logo sofia-avatar"
              />
              <span className="footer-logo-text">{footer.company.name}</span>
            </div>
            <p className="footer-description">
              {footer.company.description}
            </p>
            
            {/* Social Links */}
            <div className="footer-social">
              {footer.social.map((social, index) => {
                const IconComponent = socialIconMap[social.platform];
                return (
                  <a 
                    key={index}
                    href={social.url} 
                    className="social-link"
                    aria-label={social.platform}
                  >
                    <IconComponent size={20} />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} {footer.company.name}. Todos os direitos reservados.
          </p>
          <p className="footer-disclaimer">
            Trading envolve riscos. Negocie com responsabilidade.
          </p>
        </div>
      </div>
    </footer>
  );
};
